import { AccessControlDto, KnownIvokeAccessControlRequestDtoAction } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useConfirmationAction } from '../../../hooks/confirmation-action.hook';
import { useMutationInvokeAccessControl } from '../../hubs.queries';
import {
  ConfirmationModal,
  ConfirmationNote
} from '../../../../ui/components/pure/modal-content/confirmation-modal.component';

export function InvokeAccessControlComponent({
  onAbort,
  onSuccess,
  accessControl
}: {
  accessControl: AccessControlDto;
  onAbort(): void;
  onSuccess(): void;
}) {
  const { onConfirm, state } = useConfirmationAction({
    mutationHook: useMutationInvokeAccessControl,
    mutationArgs: (note?: ConfirmationNote) => ({
      accessControlID: accessControl.id,
      action: KnownIvokeAccessControlRequestDtoAction.Open,
      note: {
        content: note?.content ?? '',
        private: note?.visibility === 'private'
      }
    }),
    onSuccess,
    modalCloseDelay: 300
  });

  // Note: these values will be dynamicaly set when we have more use cases
  const title = 'Unlock Room';
  const content = [
    'Only open the room if you have thoroughly verified the identity of anyone at the room requiring access.'
  ];
  const noteMessage = 'Why are you manually unlocking the door?';
  const actionButtonLabel = 'Unlock';

  return (
    <ConfirmationModal
      title={title}
      content={content}
      noteRequired
      noteMessage={noteMessage}
      onConfirm={onConfirm}
      onCancel={onAbort}
      actionButton={{
        label: actionButtonLabel,
        color: 'danger'
      }}
      cancelButton={{
        label: 'Cancel'
      }}
      {...state}
    />
  );
}
